import { render } from "./EmployeesHeaderComponent.vue?vue&type=template&id=4ab7f8d2"
import script from "./EmployeesHeaderComponent.vue?vue&type=script&lang=js"
export * from "./EmployeesHeaderComponent.vue?vue&type=script&lang=js"

import "./EmployeesHeaderComponent.vue?vue&type=style&index=0&id=4ab7f8d2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__